/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upgrade_PendingInputs */



/**
* | output |
* | --- |
* | "Upgrade is processing. Please refresh in a moment." |
*
* @param {Plan_Upgrade_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_upgrade_pending = /** @type {((inputs?: Plan_Upgrade_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upgrade_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgrade wird verarbeitet. Bitte in einem Moment aktualisieren.")
	return /** @type {LocalizedString} */ ("Upgrade is processing. Please refresh in a moment.")
});